import { Component, Input } from "@angular/core";
import { Location } from "@angular/common";

@Component({
  selector: "app-error-page",
  standalone: false,
  templateUrl: "./error-page.component.html",
  styleUrl: "./error-page.component.css",
})
export class ErrorPageComponent {
  constructor(private location: Location) {}

  retry() {
    this.location.back();
  }
}
